import { useMutation } from "@tanstack/react-query";
import { TagToCreate } from "../types";
import { useRefreshAlgoliaData } from "entities/algolia/hooks/useRefreshAlgoliaData";
import { invalidateTagDetailsQuery } from "./useTagDetailsQuery";
import { createTag } from "../api/createTag";

type Params = {
  tag: TagToCreate;
};

const INITIAL_DELAY_MS = 2000;
const REFRESH_INTERVAL_MS = 5000;

export const useCreateTagQuery = () => {
  const { refreshAlgoliaData } = useRefreshAlgoliaData();

  return useMutation({
    mutationFn: async ({ tag }: Params) => {
      const response = await createTag(tag);
      invalidateTagDetailsQuery(String(response.id));
    },
    onSuccess: (_) => {
      // Invalidate query and refetch Algolia
      refreshAlgoliaData(INITIAL_DELAY_MS);
      refreshAlgoliaData(REFRESH_INTERVAL_MS);
    },
    onError: (e) => console.error(e),
  });
};
